import { RouteProperties } from '../types/RouteProperties'
import { AdminDashboard } from 'pages/Admin'
import DbIndex from '../../../pages/Db/DbIndex'
import { TUserTag } from '@centra/centra-ui'

const CENTRA_EMPLOYEE: TUserTag[] = ['role.admin', 'role.supervisor', 'role.admin-content', 'role.account-manager']
const routes: RouteProperties[] = [
  {
    component: AdminDashboard,
    exact: true,
    path: '/',
    permission: CENTRA_EMPLOYEE,
  },
  {
    component: DbIndex,
    exact: true,
    path: '/db',
    permission: CENTRA_EMPLOYEE,
  },
  {
    component: DbIndex,
    exact: true,
    path: '/db/:entityId',
    permission: CENTRA_EMPLOYEE,
  },
  {
    component: DbIndex,
    exact: true,
    path: '/db/:entityId/:objectId',
    permission: CENTRA_EMPLOYEE,
  },
  {
    component: DbIndex,
    exact: true,
    path: '/db/:entityId/:objectId/:operator',
    permission: CENTRA_EMPLOYEE,
  },
]

export default routes
